import React from 'react';
import { Modal, Button, Typography, Space } from '@duxton-web/ui';
import { CloseUniversal } from '@duxton-web/icons';
import { handleCampaignDuplicate } from 'omega-rtc/utils/campaign-utils';

/**
 * Campaign Duplicate Confirmation Popup
 * @param {Object} props - Component props
 * @param {boolean} props.visible - Whether the popup is visible
 * @param {Function} props.onClose - Function to call when popup is closed
 * @param {string} props.projectId - Project ID
 * @param {string} props.campaignId - Campaign ID
 * @param {string} props.templateType - Template type
 * @param {Object} [props.router] - Router object for navigation (optional)
 * @returns {JSX.Element}
 */
const CampaignDuplicateConfirmationPopup = ({
  visible,
  onClose,
  projectId,
  campaignId,
  templateType,
  router,
}) => {
  const handleDuplicateWithContent = () => {
    handleCampaignDuplicate({
      projectId,
      campaignId,
      templateType,
      router,
      copyContent: true,
    });
    onClose();
  };

  const handleDuplicateWithoutContent = () => {
    handleCampaignDuplicate({
      projectId,
      campaignId,
      templateType,
      router,
      copyContent: false,
    });
    onClose();
  };

  return (
    <Modal
      title="Duplicate campaign"
      open={visible}
      onCancel={onClose}
      closeIcon={<CloseUniversal style={{ fontSize: '20px' }} />}
      style={{
        borderRadius: '16px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        marginLeft: '-250px', // Half of typical modal width
        marginTop: '-150px', // Half of typical modal height
      }}
      footer={
        <Space style={{ justifyContent: 'flex-end' }}>
          <Button
            onClick={handleDuplicateWithoutContent}
            style={{
              borderRadius: '20px',
              height: '40px',
              padding: '0 24px',
            }}
          >
            No, setup only
          </Button>
          <Button
            type="primary"
            onClick={handleDuplicateWithContent}
            style={{
              borderRadius: '20px',
              height: '40px',
              padding: '0 24px',
            }}
          >
            Yes, include content
          </Button>
        </Space>
      }
    >
      <div style={{ paddingBottom: '16px' }}>
        <Typography.Text style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.85)', textAlign: 'left', display: 'block' }}>
          Would you like to include content variants in the duplicated campaign?
        </Typography.Text>
      </div>
    </Modal>
  );
};

export default CampaignDuplicateConfirmationPopup;
